// extracted by mini-css-extract-plugin
module.exports = {"dot":"dot--CalendarColorDot-components__2FgKA"};